import React, {useEffect, useState} from 'react';
import {Link} from "@mui/material";
import {Account} from "../../types/Account";

interface ViewLegalAgreementProps {
  account: Pick<Account, "supplierLegalAgreementFileName">;
  legalAgreementFile?: File;
}

const ViewLegalAgreement = (props: ViewLegalAgreementProps) => {
  const {account, legalAgreementFile} = props;

  const [objectUrl, setObjectUrl] = useState<string>();

  useEffect(() => {
    if (!legalAgreementFile) {
      setObjectUrl(undefined);
      return;
    }
    const url = URL.createObjectURL(legalAgreementFile);
    setObjectUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [legalAgreementFile]);

  if (objectUrl) {
    return <Link
      href={objectUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      View Uploaded Legal Agreement
    </Link>;
  }

  return account.supplierLegalAgreementFileName ? <Link
    href={`https://s3-us-west-1.amazonaws.com/securspace-files/legal-agreements/${account.supplierLegalAgreementFileName}`}
    target="_blank"
    rel="noopener noreferrer"
  >
    View Current Legal Agreement
  </Link> : null;
}

export default ViewLegalAgreement;
